"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.CodeFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M9.73214 3.6627C9.822 3.25835 9.56705 2.85772 9.1627 2.76786C8.75835 2.678 8.35772 2.93295 8.26786 3.3373L6.26786 12.3373C6.178 12.7417 6.43295 13.1423 6.8373 13.2321C7.24165 13.322 7.64228 13.067 7.73214 12.6627L9.73214 3.6627Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M10.4368 4.17402C10.1425 4.46543 10.1401 4.9403 10.4315 5.23467L13.4091 8.24255L10.4315 11.2504C10.1401 11.5448 10.1425 12.0197 10.4368 12.3111C10.7312 12.6025 11.2061 12.6001 11.4975 12.3057L14.6492 9.12196C15.1315 8.63485 15.1315 7.85026 14.6492 7.36315L11.4975 4.17938C11.2061 3.88501 10.7312 3.88261 10.4368 4.17402Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M5.52754 4.17402C5.8219 4.46543 5.8243 4.9403 5.53289 5.23467L2.55523 8.24256L5.53289 11.2504C5.8243 11.5448 5.8219 12.0197 5.52754 12.3111C5.23317 12.6025 4.7583 12.6001 4.46689 12.3057L1.31512 9.12197C0.8329 8.63485 0.832897 7.85027 1.31512 7.36315L4.46689 4.17938C4.7583 3.88501 5.23317 3.88261 5.52754 4.17402Z", fill: colors[0] }));
    },
    name: 'code_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M9.73214 3.6627C9.822 3.25835 9.56705 2.85772 9.1627 2.76786C8.75835 2.678 8.35772 2.93295 8.26786 3.3373L6.26786 12.3373C6.178 12.7417 6.43295 13.1423 6.8373 13.2321C7.24165 13.322 7.64228 13.067 7.73214 12.6627L9.73214 3.6627Z', 'M10.4368 4.17402C10.1425 4.46543 10.1401 4.9403 10.4315 5.23467L13.4091 8.24255L10.4315 11.2504C10.1401 11.5448 10.1425 12.0197 10.4368 12.3111C10.7312 12.6025 11.2061 12.6001 11.4975 12.3057L14.6492 9.12196C15.1315 8.63485 15.1315 7.85026 14.6492 7.36315L11.4975 4.17938C11.2061 3.88501 10.7312 3.88261 10.4368 4.17402Z', 'M5.52754 4.17402C5.8219 4.46543 5.8243 4.9403 5.53289 5.23467L2.55523 8.24256L5.53289 11.2504C5.8243 11.5448 5.8219 12.0197 5.52754 12.3111C5.23317 12.6025 4.7583 12.6001 4.46689 12.3057L1.31512 9.12197C0.8329 8.63485 0.832897 7.85027 1.31512 7.36315L4.46689 4.17938C4.7583 3.88501 5.23317 3.88261 5.52754 4.17402Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
